import * as React from "react";
import { makeStyles, tokens, useId, Label, SpinButton } from "@fluentui/react-components";

export default function NumericInput({
  value,
  onChange,
  smallStep,
  mediumStep,
  precision,
  unit,
  className,
  style,
  size,
  min,
  max,
  step,
  disabled,
  placeholder,
  defaultValue,
  appearance = "filled-lighter"
}) {
  const id = useId();

  const [spinButtonValue, setSpinButtonValue] = React.useState(value);

  React.useEffect(() => {
    setSpinButtonValue(value);
  }, [value]);

  const onSpinButtonChange = React.useCallback(
    (_ev, data) => {
      if (data.value !== undefined) {
        onChange(data.value);
        setSpinButtonValue(data.value);
      } else if (data.displayValue !== undefined) {
        const newValue = parseFloat(data.displayValue.replace(unit, "").trim());
        if (!Number.isNaN(newValue)) {
          onChange(newValue);
          setSpinButtonValue(newValue);
        } else {
          console.error(`Cannot parse "${data.displayValue}" as a number.`);
        }
      }
    },
    [setSpinButtonValue, onChange, unit]
  );

  return (
    <SpinButton
      defaultValue={defaultValue}
      disabled={disabled}
      className={className}
      style={style}
      size={size}
      appearance={appearance}
      value={spinButtonValue}
      onChange={onSpinButtonChange}
      id={id}
      precision={precision || 2}
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
    />
  );
}
